const MtrDotsOutline={
    "name": "mtr-dots",
    "theme": "outline",
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 24 24"
        },
        "children": [
            {
                "tag": "g",
                "attrs": {
                    "fill": "currentColor",
                    "fill-rule": "evenodd"
                },
                "children": [
                    {
                        "tag": "circle",
                        "attrs": {
                            "cx": "5",
                            "cy": "12",
                            "r": "2"
                        }
                    },
                    {
                        "tag": "circle",
                        "attrs": {
                            "cx": "12",
                            "cy": "12",
                            "r": "2"
                        }
                    },
                    {
                        "tag": "circle",
                        "attrs": {
                            "cx": "19",
                            "cy": "12",
                            "r": "2"
                        }
                    }
                ]
            }
        ]
    }
};
export default MtrDotsOutline;